<div class="layout-alpha">
  <nz-layout>
    <div class="layout-alpha__main">
      <nz-content #content class="layout-alpha__content">
        <router-outlet></router-outlet>
        <nz-footer class="layout-alpha__footer">
          <app-footer></app-footer>
        </nz-footer>
      </nz-content>

      <header class="layout-alpha__sidebar">
        <app-sidebar></app-sidebar>
      </header>
    </div>
  </nz-layout>

  <div class="layout-alpha__background"></div>
  <div class="layout-alpha__hexagon"></div>
</div>